export const SUBMIT_MULTI_ASK = 'iron/multi-ask/SUBMIT_MULTI_ASK';
export const submitMultiAsk = (data) => ({
  type: SUBMIT_MULTI_ASK,
  payload: { data },
});

export const SET_ERROR_MSG = 'iron/multi-ask/SET_ERROR_MSG';
export const setErrorMsg = (errorMsg) => ({
  type: SET_ERROR_MSG,
  payload: { errorMsg },
});

export const SET_SUCCESS = 'iron/multi-ask/SET_SUCCESS';
export const setSuccess = () => ({
  type: SET_SUCCESS,
});

export const RESET_MULTI_ASK = 'iron/multi-ask/RESET_MULTI_ASK';
export const resetMultiAsk = () => ({
  type: RESET_MULTI_ASK,
});
